import React from 'react';
import { partial } from 'lodash';
import { Alert } from 'reactstrap';
import { SwitchItem } from '../../Forms/SwitchItem';
import { getTranslationKey } from '../../../modules/utils';
import { IShopSalesAutomation } from '../../../modules/types';
import { SWITCH_DIRECTION, SUPPORT_LINKS } from './constants';

interface IProps {
  marketingPhotobooks: IShopSalesAutomation['marketingPhotobooks'];
  hasPhotobooks: boolean;
  isOnlyDigitalShopActive: boolean;
  isCollectionLevelSetting: boolean;
  updateFormValue: (path: string, value: unknown) => void;
}

export const MarketingPhotobooksSection = React.memo(
  ({
    marketingPhotobooks,
    hasPhotobooks,
    isOnlyDigitalShopActive,
    isCollectionLevelSetting,
    updateFormValue
  }: IProps) => (
    <>
      <SwitchItem
        value={marketingPhotobooks?.enabled}
        changeCallback={partial(updateFormValue, 'marketingPhotobooks.enabled')}
        label={getTranslationKey('collectionShop.marketingPhotobook')}
        direction={SWITCH_DIRECTION}
        margin="15px 0 5px 0"
        id="marketingPhotobooks-switch"
        withTooltip
        tooltipText={getTranslationKey('learnMoreLink', {
          link: SUPPORT_LINKS.marketingPhotobook,
          text_link: SUPPORT_LINKS.marketingPhotobook
        })}
        isIconTooltip
      />

      {(!hasPhotobooks || isOnlyDigitalShopActive) &&
        marketingPhotobooks?.enabled &&
        isCollectionLevelSetting && (
          <Alert color="warning" style={{ marginLeft: '38px', maxWidth: '300px' }}>
            {getTranslationKey('collectionShop.marketingPhotobookDisabled')}
          </Alert>
        )}
    </>
  )
);
